<template>
    <nav class="" role="navigation" style="overflow-y: auto">
        <p class="m-0 text-center remaining-time noselect">
            <span :class="tokenExpiration < 60 ? 'near-to-expiration' : ''">{{remainingAccountTime}}</span>
            <span class="btn-refresh" v-if="tokenExpiration < 60 && tokenExpiration > 0" @click="refreshToken">&nbsp;<i class="fa fa-sync"></i></span>
        </p>
        <ul class="nav navbar-nav flex-column">
            <li class="">
                <router-link
                    :class="[isRouteAtStart() ? 'active' : '']"
                    :to="{name:'app.start'}">{{$t('components.dashboard.title')}}
                </router-link>
            </li>
            <li class="">
                <a class="cursor-button" href="javascript:void(0)" @click="faultReport">{{$t('fault-report')}}</a>
            </li>
            <li class="" v-if="isAdmin">
                <router-link
                    :class="[urlContains('administration') ? 'active' : '']"
                    :to="{name:'app.admin'}">{{$t('components.administration.title')}}
                </router-link>
            </li>

            <li class="" v-if="$store.getters['configStore/getStocklistModuleStatus']">
                <router-link
                    :class="[urlContains('stocklist') ? 'active' : '']"
                    :to="{name:'app.stocklist'}">{{$t('components.stocklist.title')}}
                </router-link>
            </li>

            <li v-if="$store.getters['authStore/fromUSA']">
                <router-link
                    :class="[urlContains('stocklist-transit') ? 'active' : '']"
                    :to="{name:'app.stocklist.transit'}">{{$t('components.stocklist.title')}} {{$t('components.stocklist-transit.title')}} (USA)
                </router-link>
            </li>

            <li v-if="!$store.getters['authStore/fromUSA'] && $store.getters['configStore/getShopOrdModuleStatus']">
                <router-link
                    :class="[urlContains('under-production') ? 'active' : '']"
                    :to="{name:'app.shopord'}">{{$t('components.shopord.title')}}
                </router-link>
            </li>

            <li v-if="$store.getters['configStore/getMixedStockModuleStatus']">
                <router-link
                    :class="[urlContains('stock') ? 'active' : '']"
                    :to="{name:'app.stock-mixed'}">{{$t('components.stock-mixed.title')}}
                </router-link>
            </li>

            <li class="panel panel-default">
                <a data-toggle="collapse" href="javascript:void(0)" @click="toggle('productPanel')"
                   :class="[urlContains('products') ? 'active' : '']">
                    <span class="glyphicon glyphicon-user"></span> {{$t('components.products.title')}}
                    <span v-if="this.isLoading" class="fa fa-spinner fa-spin float-right"></span>
                    <span v-else class="fa fa-caret-down float-right"></span>
                </a>

                <div :class="['panel-collapse', !urlContains('products') ? 'collapse' : '']" ref="productPanel">
                    <div class="panel-body">
                        <ul class="nav navbar-nav">
                            <li v-for="category in productCategories" :key="category.name">
                                <div v-if="category.children.length > 0">
                                    <SidebarNavigationSubItem
                                        :sub-item="category.children"
                                        :parent="category"
                                        :prev-slugs="category.slug"
                                        :type="'product'"
                                        type-alt="products"/>
                                </div>
                                <div v-else>
                                    <router-link :class="isActive('products', category.slug) ? 'active' : ''"
                                                 :to="{name: 'app.product.category', params: {
                                            category: encodeURI(category.slug)}}">
                                        {{category.name}}
                                    </router-link>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </li>

            <li class="">
                <router-link
                    :class="[urlContains('news') ? 'active' : '']"
                    :to="{name: 'app.news'}">{{$t('components.news.title')}}
                </router-link>
            </li>

            <li class="">
                <router-link
                    :class="[urlContains('media') ? 'active' : '']"
                    :to="{name: 'app.media'}">{{$t('components.media.title')}}
                </router-link>
            </li>
        </ul>
    </nav>
</template>

<script>
import SidebarNavigationSubItem from "./SidebarNavigationSubItem";
import {EVENT_LANG_CHANGE_SIDEBAR, EVENT_TOKEN_REFRESHED} from "@/core/constants";
import AccountApiService from "../../api/account.api";

export default {
    name: "SidebarNavigation",
    components: {SidebarNavigationSubItem},
    created() {
        this.fetch();
    },
    mounted() {
        this.initTimeInterval();
        this.$eventBus.$on(EVENT_LANG_CHANGE_SIDEBAR, () => {
            this.isLoading = true;
            this.$store.dispatch('categoryStore/clearCache')
                .then(() => {
                    this.fetch();
                });
        });

        this.$eventBus.$on(EVENT_TOKEN_REFRESHED, jwt => this.initTimeInterval(jwt.expiration));
    },
    data() {
        return {
            isLoading: true,
            tokenExpiration: 0,
            timeInterval: null,
        }
    },
    methods: {
        fetch() {
            this.$store.dispatch(`categoryStore/fetch`)
                .then(() => {
                    this.isLoading = false;
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },

        toggle(target) {
            if (this.$refs[target].classList.contains('collapse')) {
                this.$refs[target].classList.remove('collapse');
            } else {
                this.$refs[target].classList.add('collapse');
            }
        },

        isActive(category, slug) {
            return this.$route.fullPath.indexOf(`/${category}/${slug}`) !== -1;
        },

        urlContains(part) {
            return window.location.href.indexOf(part) !== -1;
        },

        isRouteAtStart() {
            return this.$route.name === this.$router.resolve({name: 'app.start'}).route.name;
        },

        initTimeInterval(expiration = null) {
            if (!expiration) {
                expiration = this.$store.getters['authStore/tokenExpiration'];
            }
            this.tokenExpiration = Math.round(expiration - (Date.now() / 1000));
            if (this.timeInterval !== null) {
                clearInterval(this.timeInterval);
                this.timeInterval = null;
            }

            this.timeInterval = setInterval(() => {
                this.tokenExpiration--;
            }, 1000);
        },

        refreshToken() {
            return AccountApiService.get();
        },

        faultReport() {
            return window.open(this.$store.getters['authStore/getUrls'].fault_report, '_blank')
        }
    },

    computed: {
        productCategories: function () {
            return this.$store.getters["categoryStore/getProductItems"];
        },

        isAdmin() {
            return this.$store.getters['authStore/isAdmin'] ?? false;
        },

        remainingAccountTime() {
            let duration = this.tokenExpiration;
            let minutes = Math.floor((duration % 3600) / 60);
            let seconds = Math.floor(duration % 60);
            return (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
        },

    },

    watch: {
        tokenExpiration: function () {
            if (this.tokenExpiration <= 0) {
                clearInterval(this.timeInterval);
                this.tokenExpiration = 0;
                this.$store.dispatch('authStore/logout')
                    .then(() => {
                        this.$swal.fire({
                            icon: 'warning',
                            title: this.$t('components.login.title'),
                            html: this.$t('components.login.session-expired')
                        });
                        this.$router.push({name: 'app.guest'});
                    });
            }
        }
    }
}
</script>

<style scoped>

.remaining-time {
    font-size: 17px !important;
    font-weight: bold;
}

.near-to-expiration {
    animation: near-to-expiration-flash 1s linear infinite;
}

@keyframes near-to-expiration-flash {
    50% {
        opacity: 0.4;
    }
}

.btn-refresh {
    cursor: pointer;
}
</style>
